import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { api_getBannerGroupByCode, api_getBannerGroupsByParentCode, api_getBannersByBannerGroupName } from '~/backend/api_calls';

const BannerGroups = () => {
	const groupParentCode = 'GROUPED_BANNERS';
	const [parentGroup, setParentGroup] = useState({});
	const [groups, setGroups] = useState([]);
	const [banners, setBanners] = useState([]);
	const [selectedBanner, setSelectedBanner] = useState([]);

	useEffect(() => {
		api_getBannerGroupByCode(groupParentCode)
			.then(res => setParentGroup(res))
			.catch(err => console.log(err));

		api_getBannerGroupsByParentCode(groupParentCode)
			.then(json => {
				const groups = json.items;
				setGroups(groups);

				if (groups.length !== 0) {
					Promise.all(
						groups.map(group =>
							api_getBannersByBannerGroupName(group.nm)
								.then(json => ({
									id: group.id,
									groupTitle: group.nm,
									items: json.items
								}))
								.catch(error => {
									console.log(error);
								})
						)
					)
						.then(bannersData => {
							setBanners(bannersData);
							setSelectedBanner(bannersData[0]);
						})
						.catch(err => console.log(err));
				}
			})
			.catch(error => {
				console.log(error);
			});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [groupParentCode]);

	if (groups.length === 0 || banners.length === 0) return null;

	return (
		<section className="banner-groups content-wrapper">
			<div className="section-title">{parentGroup.nm}</div>

			<div className="tabs-title-container">
				{banners.map(banner => (
					<button
						key={banner.id}
						className={`tab-title tab-button ${selectedBanner.id === banner.id ? 'active' : ''}`}
						onClick={() => setSelectedBanner(banner)}>
						{banner.groupTitle}
					</button>
				))}
			</div>

			<Swiper
				navigation={true}
				spaceBetween={24}
				breakpoints={{
					0: {
						slidesPerView: 1
					},
					768: {
						slidesPerView: 2
					},
					1024: {
						slidesPerView: 3
					}
				}}
				className="banners-container"
				modules={[Navigation]}>
				{selectedBanner.items?.map(item => (
					<SwiperSlide key={item.id} className="banner">
						<div className="image-links">
							<img src={item.img1} alt="Img1" />
							<div className="links">
								{item.nu && (
									<Link className="banner-link" to={item.nu} target={item.ut}>
										{item.rct && item.rct !== '' ? item.rct : 'Show More'}
									</Link>
								)}
								{[2, 3, 4].map(index => {
									const nu = item[`nu${index}`];
									const ut = item[`ut${index}`];
									const rct = item[`rct${index}`];

									return (
										nu && (
											<Link key={index} className="banner-link" to={nu} target={ut}>
												{rct && rct !== '' ? rct : 'Show More'}
											</Link>
										)
									);
								})}
							</div>
						</div>
						<div className="banner-title">{item.tl}</div>
						<div className="mobile-links">
							{item.nu && (
								<Link className="banner-link" to={item.nu} target={item.ut}>
									{item.rct && item.rct !== '' ? item.rct : 'Show More'}
								</Link>
							)}
							{[2, 3, 4].map(index => {
								const nu = item[`nu${index}`];
								const ut = item[`ut${index}`];
								const rct = item[`rct${index}`];

								return (
									nu && (
										<Link key={index} className="banner-link" to={nu} target={ut}>
											{rct && rct !== '' ? rct : 'Show More'}
										</Link>
									)
								);
							})}
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</section>
	);
};

export default BannerGroups;
